import styled from 'styled-components/macro';
import media from '../../styled/breakpoint';
import { getFlex } from '../../styled/styleUtils';

export const EditorFormWrapper = styled.section`
  .add-btn {
    width: 100%;
    ${getFlex('center')};
    background: none;
    border: none;
    padding: 0.5rem;
    cursor: pointer;
    border-radius: 5px;
    transition: background 200ms var(--ease-in-out-quad);
    color: var(--indigo-500);
    &:hover {
      background: var(--indigo-100);
    }
  }
`;

export const EditorFormHeader = styled.header`
  ${getFlex('space-between')}
  padding: 2rem 0 1rem;
`;

export const FormInputLabel = styled.label`
  color: var(--blueGray-700);
  font-weight: 500;
  span {
    font-size: var(--fontSize-0);
  }
  input {
    display: block;
    width: 100%;
  }
`;
export const FloatingActionsWrapper = styled.div`
  ${getFlex('center')}
  position: absolute;
  left: 100%;
  top: 24px;
  padding: 1rem 1rem 1rem 0.4rem;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0;
  transition: top 350ms var(--ease-in-out-quad),
    opacity 350ms var(--ease-in-out-quad);

  button {
    ${getFlex('center')}
    padding: 0.25rem;
    border-radius: 100px;
    background: var(--orange-50);
    color: var(--orange-500);
    border: 1px solid var(--orange-200);
    cursor: pointer;
  }
`;
interface FieldBlockWrapperProps {
  hasBody: boolean;
}
export const FieldBlockWrapper = styled.div<FieldBlockWrapperProps>`
  margin-bottom: 2rem;
  position: relative;
  label {
    span {
      padding-left: 0.3rem;
      padding-bottom: 0.3rem;
      display: block;
    }
  }
  .fields {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
    align-self: flex-start;
  }
  .body {
    & > div {
      height: 100%;
    }
    label {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    textarea {
      width: 100%;
      min-height: 100px;
      flex-grow: 1;
    }
  }

  ${media.sm} {
    .fields {
      grid-template-columns: 1fr 1fr;
    }
  }
  ${media.md} {
    display: grid;
    grid-template-columns: 1.75fr 1fr;
    gap: 1rem;

    .fields {
      margin-bottom: 0;
    }
  }
  &:hover {
    ${FloatingActionsWrapper} {
      top: 40px;
      opacity: 1;
    }
  }
`;
